import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { convertTimestampToReadableDate } from '../../utils';

export default function PaperTable({ papers }) {
    const hasDates = Boolean(papers[0].startingAt)
    const hasGrades = !isNaN(papers[0].finalGrade)
    const hasEmails = Boolean(papers[0].emails)

    return (
        <TableContainer component={Paper}>
            <Table aria-label="papers">
                <TableHead>
                    <TableRow>
                        <TableCell><b>#</b></TableCell>
                        <TableCell><b>Título</b></TableCell>
                        <TableCell><b>Área</b></TableCell>
                        <TableCell><b>Qtd Avaliações</b></TableCell>
                        <TableCell><b>Avaliado por</b></TableCell>
                        {hasDates && <TableCell><b>Horários</b></TableCell>}
                        {hasGrades && <TableCell><b>Nota Final</b></TableCell>}
                        {hasEmails && <TableCell><b>E-mails</b></TableCell>}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {papers.map((p, i) => (
                        <TableRow key={i + p.paperTitle[0]}>
                            <TableCell>
                                #{i + 1}
                            </TableCell>
                            <TableCell>
                                {p.paperTitle}
                            </TableCell>
                            <TableCell>
                                {p.knowledgeArea}
                            </TableCell>
                            <TableCell>
                                {Object.values(p.reports).length}
                            </TableCell>
                            <TableCell>
                                {Object.values(p.reports).map(r => (
                                    r.accessCode + ',\n'
                                ))}
                            </TableCell>
                            {p.startingAt && (
                                <TableCell>
                                    {convertTimestampToReadableDate(p.startingAt)}
                                    {`\n${String.fromCharCode(0x2014)}\n`}
                                    {convertTimestampToReadableDate(p.endingAt)}
                                </TableCell>
                            )}
                            {hasGrades && (
                                <TableCell>
                                    {p.finalGrade}
                                </TableCell>
                            )}
                            {hasEmails && (
                                <TableCell>
                                    {
                                        p.emails.map(e => (
                                            e + ',\n'
                                        ))
                                    }
                                </TableCell>
                            )}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
